import { Divider, Heading, Icon, IconButton, Popover, TextButton } from '@zillow/constellation-10';
import { IconDeleteOutline } from '@zillow/constellation-icons';

type DeleteReplyButtonProps = {
  title: string;
  replyIndex: number;
  handleDelete: (replyIndex: number) => void;
  isDisabled: boolean;
};

export default function DeleteReplyButton({ title, replyIndex, handleDelete, isDisabled }: DeleteReplyButtonProps) {
  return (
    <Popover
      trigger={
        <IconButton
          data-testid="saved-reply-delete-btn"
          disabled={isDisabled}
          emphasis="bare"
          shape="circle"
          size="md"
          title={`Delete ${title} message`}
          tone="brand"
        >
          <Icon>
            <IconDeleteOutline />
          </Icon>
        </IconButton>
      }
      header={
        <Heading level={3} data-testid="delete-saved-reply-header">
          Permanently delete {title}?
        </Heading>
      }
      body={
        <>
          <TextButton
            disabled={isDisabled}
            onClick={() => handleDelete(replyIndex)}
            data-testid="saved-reply-confirm-delete-btn"
          >
            Yes, delete
          </TextButton>
          <Divider css={{ marginTop: 'default', marginBottom: 'default' }} />
          <Popover.Close>
            <TextButton disabled={isDisabled} tone="subtle">
              Cancel
            </TextButton>
          </Popover.Close>
        </>
      }
    />
  );
}
